import React from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Button } from '@lb-service/ui';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import appUtils from '../../../utils/appUtils';

const StartNow = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { locale } = router;
  return (
    <section className="bg-[#1c1c1c] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-5xl lg:px-8">
        <div className="text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-medium text-white tracking-tight leading-tight mb-4">
            {t('service.home.startNow.title1')}
          </h2>
          <p className="text-lg text-white/70 mb-10 max-w-xl mx-auto">
            {t('service.home.startNow.title2')}
          </p>
          <Button
            asChild
            size="lg"
            className="bg-[#e55425] hover:bg-[#d14a1f] text-white px-8 py-3 text-base font-medium rounded-md transition-colors"
          >
            <Link href={appUtils.getAppPath(locale, 'signup')}>
              {t('service.home.startNow.submit')}
              <ArrowRightIcon className="h-4 w-4 ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default StartNow;
